export const stopWords = new Set([
    "a", "an", "the", "and", "or", "but", "if", "then", "because", "so", "for",
    "on", "at", "to", "from", "by", "about", "as", "in", "out", "of", "off",
    "over", "under", "your", "you", "is", "are", "was", "were", "this", "that",
    "these", "those", "it", "its", "be", "been", "being", "i", "me", "my",
    "we", "our", "us", "he", "him", "his", "she", "her", "they", "them", "their",
    "with", "can", "have", "website", "will",
]);

export const calculateKeywordDensity = (text: string, filter: "single" | "short" | "long") => {
    const words = text.toLowerCase().match(/\b[a-zA-Z]{2,}\b/g) || [];
    const filteredWords = words.filter(word => !stopWords.has(word));
    const totalWords = filteredWords.length;

    if (totalWords === 0) {
        return [];
    }

    if (filter === "single") {
        const wordCounts: Record<string, number> = {};
        filteredWords.forEach(word => {
            wordCounts[word] = (wordCounts[word] || 0) + 1;
        });
        return Object.entries(wordCounts)
            .map(([keyword, count]) => ({
                keyword,
                count,
                density: ((count / totalWords) * 100).toFixed(1) + "%",
            }))
            .filter(item => item.count > 7)
            .sort((a, b) => b.count - a.count);
    } else if (filter === "short") {
        const phraseCounts: Record<string, number> = {};
        
        for (let i = 0; i < words.length - 1; i++) {
            const phrase = words.slice(i, i + 2).join(" ");
            phraseCounts[phrase] = (phraseCounts[phrase] || 0) + 1;
        }
        return Object.entries(phraseCounts)
            .map(([keyword, count]) => ({
                keyword,
                count,
                density: ((count / totalWords) * 100).toFixed(1) + "%",
            }))
            .filter(item => item.count > 2)
            .sort((a, b) => b.count - a.count);
    } else if (filter === "long") {
        const phraseCounts: Record<string, number> = {};
        
        for (let i = 0; i < words.length - 2; i++) {
            const phrase = words.slice(i, i + 3).join(" ");
            phraseCounts[phrase] = (phraseCounts[phrase] || 0) + 1;
        }
        return Object.entries(phraseCounts)
            .map(([keyword, count]) => ({
                keyword,
                count,
                density: ((count / totalWords) * 100).toFixed(1) + "%",
            }))
            .filter(item => item.count > 2)
            .sort((a, b) => b.count - a.count);
    }
    return [];
};

export const calculateSpecificKeywordDensity = (text: string, keyword: string) => {
    if (!keyword.trim()) return { count: 0, density: "0%" };

    const words = text.toLowerCase().match(/\b[a-zA-Z]{2,}\b/g) || [];
    const filteredWords = words.filter(word => !stopWords.has(word));
    const totalWords = filteredWords.length;
    const keywordLower = keyword.toLowerCase().trim();
    const keywordWords = keywordLower.split(/\s+/);
    const keywordLength = keywordWords.length;

    let count = 0;
    for (let i = 0; i < words.length - keywordLength + 1; i++) {
        const phrase = words.slice(i, i + keywordLength).join(" ");
        if (phrase === keywordLower) {
            count++;
        }
    }

    const density = totalWords > 0 ? ((count / totalWords) * 100).toFixed(1) + "%" : "0%";
    return { count, density };
};